import {
  PropType,
  defineComponent,
  onUnmounted,
  reactive,
  inject,
  ref,
  watch,
  onMounted,
} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Tracker from '@nio-fe/nio-tracker-web'
import HomeSearchInput, { HomeSearchInputProps } from '../../searchList'
import styles from './styles.module.scss'
import { Store } from 'pinia'
import {
  ComponentActions,
  ComponentState,
  useComponentStore,
} from '../../../nsh5/localStores/component'
import { useAppStore } from '../../../stores/app'
import { SearchPoint } from '../../../contract/searchPoint'
import { Badge } from 'vant'
import { clearHistory } from '@/pages/chargermap/router'

export default defineComponent({
  name: 'handle-box',
  emits: ['handleFilter', 'hideFilter', 'goBackHome', 'showFilterPopupView'],
  components: {
    'van-badge': Badge,
  },
  props: {
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },
  setup: (props) => {
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    const appStore = useAppStore()
    const componentStore = useComponentStore()

    const router = useRouter()
    const route = useRoute()

    const client = inject<string>('client', '')

    const filterNum = ref<number | null>(null)

    const state = reactive({
      input: false,
    })
    // const router = useRouter()
    const handleSelect: HomeSearchInputProps['onSelect'] = (poiResource) => {
      props.componentStore.searchListPanel && props.componentStore.bus.emit('closeSearchListPanel')
      componentStore.$patch({
        searchListPanel: false,
      }) // 关闭搜索看板
      const [lng, lat] = poiResource.location.split(',').map((val) => Number(val))
      componentStore.$patch({
        tempSearchPoiResource: {
          lng,
          lat,
          name: poiResource.name,
          pointType: poiResource.pointType,
          pointSubType: poiResource.pointSubType,
          id: poiResource.id,
          address: poiResource.address,
        } as SearchPoint,
      })
      componentStore.bus.emit('searchPoiResource', {
        lng,
        lat,
        name: poiResource.name,
        pointType: poiResource.pointType,
        pointSubType: poiResource.pointSubType,
        id: poiResource.id,
        address: poiResource.address,
      })
    }

    const handleSearchIconClick = () => {
      componentStore.tempSearchPoiResource !== null &&
        componentStore.bus.emit('searchPoiResource', componentStore.tempSearchPoiResource)
    }

    const handleFocus: HomeSearchInputProps['onFocus'] = () => {
      state.input = true

      // 搜索点击埋点
      Tracker.track('nsh5_citymapclicksearch', appStore.trackParamsCommon)
    }

    const handleBlur: HomeSearchInputProps['onBlur'] = () => {
      state.input = false
    }

    /**
     * 清除
     */
    const handleClearSearchInput = () => {
      // 还原input状态
      state.input = false
    }

    const goBackHome = (e: any) => {
      e.stopPropagation()
      props.componentStore.bus.emit('goBackHome')
    }

    const openMobileFilter = () => {
      // 打开移动端筛选
      props.componentStore.bus.emit('showFilterPopupView')
    }

    watch(
      () => props.componentStore.filter,
      () => {
        updateFilterNum()
      },
      {
        deep: true,
      }
    )

    const updateFilterNum = () => {
      filterNum.value = props.componentStore.filter.filter(
        (item) => item.selected // 不单独过滤recharge
      ).length
    }

    // 注册搜索态
    const goToSearchPanel = () => {
      if (client === 'mobile') {
        if (route.name == 'pin' || route.name == 'resource') {
          clearHistory()
        }
        componentStore.$patch({
          showSearchPanel: true,
          showHandleBox: false,
        })
      }
      handleFocus()
    }
    onUnmounted(() => {
      // componentStore.bus.off('handleClearSearchInput')
    })

    onMounted(() => {
      updateFilterNum()
    })

    return () => {
      return (
        <div class={styles.handleBoxLeft}>
          <div class={['icon', 'square']} onClick={goBackHome}>
            <ns-icon
              name={(process.config as any).icon.icon_home}
              size={client === 'mobile' ? '20px' : '24px'}
            />
          </div>
          {componentsConfig && componentsConfig.search?.show ? (
            <div class={styles.searchInput} onClick={goToSearchPanel}>
              {client === 'mobile' ? (
                <>
                  <ns-icon
                    name={(process.config as any).icon.search_mid_outline}
                    color="#999DAE"
                    size="23"
                    class={styles.searchButton}
                  />
                  <span>搜索资源</span>
                </>
              ) : (
                <HomeSearchInput
                  className={styles.input}
                  placeholder="搜索资源"
                  // modelValue={componentStore.tempSearchPoiResource?.name} // 20240912 选择搜索列表不回填到搜索框
                  onSelect={handleSelect}
                  onFocus={handleFocus}
                  onSearchIconClick={handleSearchIconClick}
                  onBlur={handleBlur}
                  onClear={handleClearSearchInput}
                />
              )}
            </div>
          ) : null}
          {client === 'mobile' ? (
            <>
              {filterNum.value ? (
                <van-badge
                  class={['icon', 'square']}
                  content={filterNum.value}
                  onClick={openMobileFilter}
                >
                  <ns-icon
                    name={(process.config as any).icon.filter_block_outline}
                    color="#040B29"
                    size="20"
                  />
                </van-badge>
              ) : (
                <div class={['icon', 'square']} onClick={openMobileFilter}>
                  <ns-icon
                    name={(process.config as any).icon.filter_block_outline}
                    color="#040B29"
                    size="20"
                  />
                </div>
              )}
            </>
          ) : null}
        </div>
      )
    }
  },
})
